/**
 * localStorage service for the "Show Multiple Colors" toggle preference.
 */

const KEY = "showMultipleColors";

/**
 * Returns the user's stored preference:
 *   true  → show all colors at once (toggle checked)
 *   false → single color mode (toggle unchecked)
 *   null  → no stored preference (first-time visitor)
 */
export function getShowAllColorsPreference(): boolean | null {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "true") return true;
    if (v === "false") return false;
    return null;
  } catch {
    return null;
  }
}

export function saveShowAllColorsPreference(showAll: boolean): void {
  try {
    localStorage.setItem(KEY, showAll ? "true" : "false");
  } catch {
    // Ignore localStorage errors
  }
}
